<dtm-ui-select-field [multiple]="true" [formControl]="category" *ngIf="categories$ | ngrxPush as categories">
    <label>{{ "dtmUi.conversations.categorySelectLabel" | transloco }}</label>
    <dtm-ui-select-option *ngFor="let category of categories" [value]="category">
        {{ "dtmUi.conversations.categoryLabel" | transloco : { value: category } }}
    </dtm-ui-select-option>
</dtm-ui-select-field>
